import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const colors = [
  {
    bgColor: '#C7DDFF',
    fgColor: '#013A90',
  },
  {
    bgColor: '#C8FFE2',
    fgColor: '#006B31',
  },
  {
    bgColor: '#F1EFED',
    fgColor: '#574841',
  },
  {
    bgColor: '#FFC7CF',
    fgColor: '#900117',
  },
  {
    bgColor: '#FFFACE',
    fgColor: '#6C6000',
  },
  {
    bgColor: '#D7FCF1',
    fgColor: '#165F49',
  },
  {
    bgColor: '#FAE0FF',
    fgColor: '#CA00F3',
  },
];

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedAvatarComponent {
  @Input() public size = 50;
  @Input() public name = '';
  @Input() public textSizeRatio = 3;
  @Input() public bgColor: string | undefined;
  @Input() public fgColor: string | undefined;
  @Input() public borderColor: string | undefined;
  @Input() public round = true;
  @Input() public src: string | null;
  @Input() public initialsSize: number;
  @Input() public value: string | null;
  @Input() public cornerRadius: string | number;

  getShortName() {
    const nameSplit = this.name?.split(' ') || [];
    return nameSplit.length > 2 ? `${nameSplit[0]} ${nameSplit[nameSplit.length - 1]}` : this.name;
  }

  getAvatarVariant() {
    const colorIdx = this.name?.split('').map(e => e.charCodeAt(0)).reduce((a, b) => a + b, 0) % colors.length;
    return colors[colorIdx || 0];
  }
}
